module.exports = __webpack_public_path__ + "img/confirm-hen.9a5b0dc5.png";